import one360 from './one360';
import type { ReportReworkPayload, ReportReworkResult, ReworkFileUploadResult } from '../../interfaces/stoerungen';

export async function uploadReworkFile(file: Blob, fileName: string): Promise<ReworkFileUploadResult> {
  const formData = new FormData();
  formData.append('file', file, fileName);
  return one360.post<ReworkFileUploadResult>('/api/v1/ops/reworks/files', formData);
}

export async function reportRework(payload: ReportReworkPayload): Promise<ReportReworkResult> {
  return one360.post<ReportReworkResult>('/api/v1/ops/reworks', payload);
}
